import { EuiFieldNumber, EuiFlexGroup, EuiFlexItem, EuiFormRow, EuiSelect } from '@elastic/eui'

import { CampaignType, DayPartitioning, FrequencyUnit } from '../../../api/interfaces'
import { CampaignDelivery } from '../../../api/interfaces/CampaignDelivery'
import { DayPartPicker } from './DayPartPicker'

type CampaignDeliveryFormProps = {
  baseDelivery: CampaignDelivery
  onTargetingChanged: (campaignDelivery: CampaignDelivery) => void
  campaignType: CampaignType
}

export const CampaignDeliveryForm = ({ baseDelivery, onTargetingChanged, campaignType }: CampaignDeliveryFormProps) => {
  const options: {
    value: FrequencyUnit
    text: string
  }[] = [
    { value: FrequencyUnit.hour, text: 'Hourly' },
    { value: FrequencyUnit.day, text: 'Daily' },
    { value: FrequencyUnit.week, text: 'Weekly' }
  ]

  const onFrequencyChange = (frequency: number) => {
    onTargetingChanged({
      ...baseDelivery,
      frequency: frequency
    })
  }

  const onFrequencyUnitChange = (frequencyUnit: FrequencyUnit) => {
    onTargetingChanged({
      ...baseDelivery,
      frequencyUnit: frequencyUnit
    })
  }

  const onDayPartsChange = (dayParts: DayPartitioning) => {
    onTargetingChanged({
      ...baseDelivery,
      dayParts: dayParts
    })
  }

  return (
    <>
      <EuiFlexGroup direction='column'>
        <EuiFlexItem>
          {campaignType !== CampaignType.Billboard && (
            <EuiFormRow label={'Frequency'}>
              <EuiFlexGroup>
                <EuiFlexItem grow={false}>
                  <EuiFieldNumber
                    fullWidth
                    value={baseDelivery.frequency}
                    step={1}
                    onChange={e => {
                      onFrequencyChange(Number(e.target.value))
                    }}
                    min={0}
                    append={'views / user'}
                  />
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  <EuiSelect options={options} value={baseDelivery.frequencyUnit} hasNoInitialSelection={!baseDelivery.frequency} onChange={e => onFrequencyUnitChange(e.target.value as any as FrequencyUnit)} />
                </EuiFlexItem>
              </EuiFlexGroup>
            </EuiFormRow>
          )}
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiFormRow label='Day Partitioning' fullWidth>
            <DayPartPicker onSelectedDayPartsChange={onDayPartsChange} dayParts={baseDelivery.dayParts} />
          </EuiFormRow>
        </EuiFlexItem>
      </EuiFlexGroup>
    </>
  )
}
